import { StateStorage } from 'zustand/middleware'
import { createStore } from '../.'

export type AppearanceTone = 'night' | 'flux'

interface AppearanceStore {
  tone: AppearanceTone
  setTone: (tone: AppearanceTone) => void
}

export const createAppearanceStore = (storage: StateStorage) =>
  createStore<AppearanceStore>(
    storage,
    (set) => ({
      tone: 'night',
      setTone(tone) {
        set({ tone })
      },
    }),
    {
      persist: {
        name: 'appearance',
        version: 0,
      },
    }
  )
